module.exports = __webpack_public_path__ + "img/titleImg.f80db425.png";